import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StatementOfAccountEventCustomerCategoryFilterModel } from "../../../../../../models/aggregates/erp/statement-of-account/statement-of-account-event-customer-category-filter.model";

@Injectable({ providedIn: "root" })
export class StatementOfAccountEventCustomerCategoryFilterService extends BaseApiTemplateService<StatementOfAccountEventCustomerCategoryFilterModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
    "event-filter-customer-categories/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "event-filter-customer-categories/backoffice-ep";
    this.httpClient = theHttp;
  }
}
